import React from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';

function FirstTimeGuide() {
  return (
    <div className="terms-container">
      <div className="terms-header">
        <Link to="/recruitments" className="back-link">← 募集一覧へ</Link>
        <h1>初めてのヤマッチ</h1>
      </div>

      <div className="terms-content">
        <section className="terms-section">
          <p style={{ fontSize: '1.05rem', marginBottom: '2rem' }}>
            ようこそ、ヤマッチへ。<br />
            ここでは、登山仲間を見つけることができます。<br />
            でも最初は、少し不安ですよね。
          </p>

          <div className="terms-article">
            <h2>安心して使うために</h2>
            <p>ヤマッチでは、いきなり会う必要はありません。</p>
            <ul style={{ marginTop: '0.75rem', paddingLeft: '1.5rem', lineHeight: '2' }}>
              <li>参加前にメッセージで確認できます</li>
              <li>無理に参加する必要はありません</li>
              <li>自分に合う募集だけ選べます</li>
            </ul>
          </div>

          <div className="terms-article">
            <h2>大切なことはひとつ</h2>
            <p style={{ fontSize: '1.05rem', fontWeight: 600 }}>無理をしないこと</p>
            <p style={{ marginTop: '0.5rem' }}>
              少しでも不安があれば、参加しなくて大丈夫です。
            </p>
          </div>

          <div className="terms-article">
            <h2>まずはここから</h2>
            <p style={{ marginBottom: '0.75rem' }}>おすすめの使い方：</p>
            <ol style={{ paddingLeft: '1.5rem', lineHeight: '2' }}>
              <li>気になる募集を見つける</li>
              <li>内容を確認する（レベル・コース）</li>
              <li>メッセージで質問する</li>
            </ol>
          </div>

          <div className="terms-article">
            <h2>最初に選ぶなら</h2>
            <ul style={{ paddingLeft: '1.5rem', lineHeight: '2' }}>
              <li>初心者歓迎</li>
              <li>複数人の山行</li>
            </ul>
            <p style={{ marginTop: '0.5rem' }}>この2つが安心です。</p>
          </div>

          <div className="terms-article">
            <h2>個人情報について</h2>
            <p>
              最寄り駅などの情報は、必要な相手にだけ、期間限定で共有されます。
            </p>
          </div>

          <div className="terms-article">
            <h2>困ったときは</h2>
            <p>
              いつでも通報・ブロックが可能です。安心してご利用ください。
            </p>
          </div>

          <div style={{ marginTop: '2.5rem', textAlign: 'center' }}>
            <Link to="/recruitments" className="btn btn-primary" style={{ display: 'inline-block', padding: '12px 32px', textDecoration: 'none' }}>
              募集一覧を見る
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}

export default FirstTimeGuide;
